module.exports = "/assets/639cc4087bb63cba2de610bff352736b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/EK.png
// module id = 1339
// module chunks = 0